export const ID = 'id'
export const STORE = 'store'
export const STORE_NAME = 'QUỲNH ĐAN BAKERY'
export const CATEGORIES = 'categories'
export const PRODUCTS = 'products'
